import {
  ENDPOINTS_CONNECTORS_PANEL_GET_LIST_INIT,
  ENDPOINTS_CONNECTORS_PANEL_GET_LIST_SUCCESS,
  ENDPOINTS_CONNECTORS_PANEL_GET_LIST_FAILURE,
  ENDPOINTS_CONNECTORS_PANEL_GET_PERIODS_LIST_INIT,
  ENDPOINTS_CONNECTORS_PANEL_GET_PERIODS_LIST_SUCCESS,
  ENDPOINTS_CONNECTORS_PANEL_GET_PERIODS_LIST_FAILURE,
  ENDPOINTS_CONNECTORS_PANEL_SET_PERIOD_ID,
  ENDPOINTS_CONNECTORS_PANEL_RUN_CONNECTOR_INIT,
  ENDPOINTS_CONNECTORS_PANEL_RUN_CONNECTOR_SUCCESS,
  ENDPOINTS_CONNECTORS_PANEL_RUN_CONNECTOR_FAILURE,
  ENDPOINTS_CONNECTORS_PANEL_GET_LAST_UPDATES_LIST_INIT,
  ENDPOINTS_CONNECTORS_PANEL_GET_LAST_UPDATES_LIST_SUCCESS,
  ENDPOINTS_CONNECTORS_PANEL_GET_LAST_UPDATES_LIST_FAILURE,
  ENDPOINTS_CONNECTORS_PANEL_GET_CALCULATION_UNITS_INIT,
  ENDPOINTS_CONNECTORS_PANEL_GET_CALCULATION_UNITS_SUCCESS,
  ENDPOINTS_CONNECTORS_PANEL_GET_CALCULATION_UNITS_FAILURE,
  ENDPOINTS_CONNECTORS_PANEL_GET_GROUPS_INIT,
  ENDPOINTS_CONNECTORS_PANEL_GET_GROUPS_SUCCESS,
  ENDPOINTS_CONNECTORS_PANEL_GET_GROUPS_FAILURE,
  ENDPOINTS_CONNECTORS_PANEL_GET_POLYNOMIALS_LIST_INIT,
  ENDPOINTS_CONNECTORS_PANEL_GET_POLYNOMIALS_LIST_SUCCESS,
  ENDPOINTS_CONNECTORS_PANEL_GET_POLYNOMIALS_LIST_FAILURE,
  ENDPOINTS_CONNECTORS_PANEL_RESET,  
} from './types';
import ActionsTooling from '../../../tooling/actionsTooling';
import Constants from '../../../definitions/constants';

export function reset() {
  return {
    type: ENDPOINTS_CONNECTORS_PANEL_RESET
  };
}

export function getPeriodsList() {
  let params = {
    mini_list_version: true, 
    order_fields: ["end_date", "created_at"],
    order_directions: [Constants.crudGenerator.orderTypes.DESC, Constants.crudGenerator.orderTypes.DESC],
    fields_are: ["active"],
    searches_are: [true],
    per_page: Constants.interface.fullListPageSize
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: ENDPOINTS_CONNECTORS_PANEL_GET_PERIODS_LIST_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/period/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(ENDPOINTS_CONNECTORS_PANEL_GET_PERIODS_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(ENDPOINTS_CONNECTORS_PANEL_GET_PERIODS_LIST_FAILURE, error));
    }  
  };
}

export function getList(params, paging = false) {
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: ENDPOINTS_CONNECTORS_PANEL_GET_LIST_INIT,
      params: params,
      paging: paging
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/endpointsconnectors/endpointsexecutionslist",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(ENDPOINTS_CONNECTORS_PANEL_GET_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(ENDPOINTS_CONNECTORS_PANEL_GET_LIST_FAILURE, error));
    }  
  };
}

export function getLastUpdates(connectorId, periodId, page = 1) {
  let params = {
    period_id: periodId,
    endpoint_connector_id: connectorId,
    order_fields: ["created_at"],
    order_directions: [Constants.crudGenerator.orderTypes.DESC],
    per_page: Constants.interface.notificationsPageSize,
    page: page
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: ENDPOINTS_CONNECTORS_PANEL_GET_LAST_UPDATES_LIST_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/endpointsconnectors/endpointexecutiondetail",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(ENDPOINTS_CONNECTORS_PANEL_GET_LAST_UPDATES_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(ENDPOINTS_CONNECTORS_PANEL_GET_LAST_UPDATES_LIST_FAILURE, error));
    }  
  };
}

export function setPeriodId(id) {
  return {
    type: ENDPOINTS_CONNECTORS_PANEL_SET_PERIOD_ID,
    id: id
  };
}

export function getCalculationUnitsList(keyword, groupId, periodId) {
  let params = {
    mini_list_version: true, 
    order_fields: ["last_names", "first_names"],
    order_directions: [Constants.crudGenerator.orderTypes.ASC, Constants.crudGenerator.orderTypes.ASC],
    fields_like: [["last_names", "first_names", "code"]],
    searches_like: [keyword, keyword, keyword],
    fields_are: [],
    searches_are: [],
    active: true,
    period_id: periodId,
    per_page: Constants.interface.fullListPageSize,
    group_id: groupId
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: ENDPOINTS_CONNECTORS_PANEL_GET_CALCULATION_UNITS_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/calculationunit/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(ENDPOINTS_CONNECTORS_PANEL_GET_CALCULATION_UNITS_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(ENDPOINTS_CONNECTORS_PANEL_GET_CALCULATION_UNITS_FAILURE, error));
    }  
  };
}

export function getGroupsList(periodId) {
  let params = {
    mini_list_version: true, 
    order_fields: ["name"],
    order_directions: [Constants.crudGenerator.orderTypes.ASC],
    fields_are: [],
    searches_are: [],
    active: true,
    period_id: periodId,
    per_page: Constants.interface.fullListPageSize
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: ENDPOINTS_CONNECTORS_PANEL_GET_GROUPS_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/group/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(ENDPOINTS_CONNECTORS_PANEL_GET_GROUPS_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(ENDPOINTS_CONNECTORS_PANEL_GET_GROUPS_FAILURE, error));
    }  
  };
}

export function getPolynomialsList() {
  let params = {
    mini_list_version: true, 
    order_fields: ["name"],
    order_directions: [Constants.crudGenerator.orderTypes.ASC],
    fields_are: ["active", "model"],
    searches_are: [true, true],
    per_page: Constants.interface.fullListPageSize
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: ENDPOINTS_CONNECTORS_PANEL_GET_POLYNOMIALS_LIST_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/polynomial/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(ENDPOINTS_CONNECTORS_PANEL_GET_POLYNOMIALS_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(ENDPOINTS_CONNECTORS_PANEL_GET_POLYNOMIALS_LIST_FAILURE, error));
    }  
  };
}

export function runConnector(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(ENDPOINTS_CONNECTORS_PANEL_RUN_CONNECTOR_INIT));   
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/endpointsconnectors/runconnector",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(ENDPOINTS_CONNECTORS_PANEL_RUN_CONNECTOR_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(ENDPOINTS_CONNECTORS_PANEL_RUN_CONNECTOR_FAILURE, error));
    }  
  };
}


// WEBPACK FOOTER //
// ./source/client/actions/endpointsConnectorsPanel/index.js